export enum GroupTypeEnum {
    MultiActivityInsert = 0,
    Writing = 1,
    FaultList = 2,
    FaultImport = 3,
    EmailServer = 4,
    Report = 5
}